import { Post } from "./common";

export default class ArtaService {
  static getQuote = async (token: string, data: any) =>
    await Post({ path: "arta", token, body: data });
}
